export const POST_META_DATA = "store/metaData/POST_META_DATA";
export const POST_META_DATA_COMPLETED = "store/metaData/POST_META_DATA_COMPLETED";
export const POST_META_DATA_FAILED = "store/metaData/POST_META_DATA_FAILED";
